import * as Types from "src/state/_types"
import * as GQL from "src/state/gql/_types"

export const TalentAdminBookingViewSchema: Types.ViewSchemaType<GQL.BookingFragment> = {
    enums: [
        {
            label: "Type",
            field: "booking_type",
            type: "booking-type-badge",
            relation_field: "display"
        },
    ],
    fields: [
        {
            label: "Date",
            field: "date",
            type: "date"
        },
        {
            label: "Event Start Time",
            field: "event_start_time",
            type: "time"
        },
        {
            label: "Event End Time",
            field: "event_end_time",
            type: "time"
        },
        {
            label: "Set Start Time",
            field: "set_start_time",
            type: "time"
        },
        {
            label: "Set End Time",
            field: "set_end_time",
            type: "time"
        },
        {
            label: "Notes",
            field: "notes",
            type: "text"
        },
        {
            label: "Rate",
            field: "rate",
            type: "currency"
        },
        {
            label: "Rate Type",
            field: "rate_type",
            type: "text"
        },
        {
            label: "Poc",
            field: "poc",
            type: "text"
        },
        {
            label: "Created At",
            field: "created_at",
            type: "datetime"
        },
        {
            label: "Updated At",
            field: "updated_at",
            type: "datetime"
        },
        {
            label: "Recurring",
            field: "recurring",
            type: "boolean"
        }
    ],
    relations: {
        series: {
            relation: "series",
            label: "Recurring Series",
            fields: [
                {
                    label: "Recurring Schedule",
                    field: "rrule",
                    type: "rrule"
                }
            ]
        },
        venue: {
            relation: "venue",
            label: "Venue",
            fields: [
                {
                    label: "Type",
                    field: "tenant_type",
                    type: "text",
                    relation_field: "display"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Address Line1",
                    field: "address_line1",
                    type: "text"
                },
                {
                    label: "Address Line2",
                    field: "address_line2",
                    type: "text"
                },
                {
                    label: "City",
                    field: "city",
                    type: "text"
                },
                {
                    label: "State",
                    field: "state",
                    type: "text"
                },
                {
                    label: "Country",
                    field: "country",
                    type: "text"
                },
                {
                    label: "Postal Code",
                    field: "postal_code",
                    type: "text"
                },
                {
                    label: "Phone",
                    field: "phone",
                    type: "text"
                }
            ]
        },
        area: {
            relation: "area",
            label: "Area",
            fields: [
                {
                    label: "Type",
                    field: "area_type",
                    type: "text",
                    relation_field: "display"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Description",
                    field: "description",
                    type: "text"
                }
            ]
        }
    }
}